export const BAR_SIZE = 6

export const DEFAULT_COLOR = '#fc9c1b'

export const DEFAULT_OPACITY = 0.5

export const BAR_RADIUS = 20
